import React from 'react';

// CSS-only animated funnel visualization
export default function FunnelCanvas() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Radial gradient background */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(0, 240, 255, 0.12) 0%, rgba(112, 0, 255, 0.05) 40%, transparent 70%)'
        }}
      />
      
      {/* Outer ring */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div 
          className="animate-spin"
          style={{
            width: '500px',
            height: '500px',
            animationDuration: '30s',
            border: '1px solid rgba(0, 240, 255, 0.15)',
            borderRadius: '50%',
            boxShadow: '0 0 80px rgba(0, 240, 255, 0.1), inset 0 0 80px rgba(0, 240, 255, 0.03)'
          }}
        />
      </div>
      
      {/* Middle ring */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div 
          className="animate-spin"
          style={{
            width: '350px',
            height: '350px',
            animationDuration: '20s',
            animationDirection: 'reverse',
            border: '1px solid rgba(112, 0, 255, 0.25)',
            borderRadius: '50%',
            boxShadow: '0 0 60px rgba(112, 0, 255, 0.1)'
          }}
        />
      </div>
      
      {/* Inner ring */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div 
          className="animate-spin"
          style={{
            width: '200px',
            height: '200px',
            animationDuration: '15s',
            border: '2px dashed rgba(0, 240, 255, 0.3)',
            borderRadius: '50%',
          }}
        />
      </div>
      
      {/* Core glow */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div 
          className="animate-pulse"
          style={{
            width: '80px',
            height: '80px',
            background: 'radial-gradient(circle, rgba(0, 240, 255, 0.4) 0%, transparent 70%)',
            borderRadius: '50%',
            animationDuration: '3s'
          }}
        />
      </div>
      
      {/* Floating particles */}
      {[...Array(30)].map((_, i) => {
        const size = Math.random() * 4 + 2;
        const delay = Math.random() * 5;
        const duration = Math.random() * 8 + 6;
        const startX = Math.random() * 100;
        const startY = Math.random() * 100;
        const isCyan = i % 3 !== 0;
        
        return (
          <div
            key={i}
            className="absolute rounded-full"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              left: `${startX}%`,
              top: `${startY}%`,
              backgroundColor: isCyan ? '#00F0FF' : '#7000FF',
              opacity: 0,
              boxShadow: isCyan 
                ? '0 0 15px rgba(0, 240, 255, 0.6)' 
                : '0 0 15px rgba(112, 0, 255, 0.6)',
              animation: `floatParticle ${duration}s ease-in-out ${delay}s infinite`
            }}
          />
        );
      })}
      
      {/* Funnel shape overlay */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        <svg 
          width="400" 
          height="500" 
          viewBox="0 0 400 500" 
          fill="none"
          className="opacity-20"
        >
          <path
            d="M50 50 L350 50 L250 450 L150 450 Z"
            stroke="url(#funnelGrad)"
            strokeWidth="2"
            fill="none"
            strokeDasharray="10 5"
            className="animate-pulse"
            style={{ animationDuration: '4s' }}
          />
          <defs>
            <linearGradient id="funnelGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#00F0FF" />
              <stop offset="100%" stopColor="#7000FF" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      <style>{`
        @keyframes floatParticle {
          0%, 100% {
            opacity: 0;
            transform: translateY(0) scale(0);
          }
          10% {
            opacity: 0.8;
            transform: translateY(-20px) scale(1);
          }
          50% {
            opacity: 0.6;
            transform: translateY(-100px) scale(0.8);
          }
          90% {
            opacity: 0.3;
            transform: translateY(-200px) scale(0.4);
          }
        }
      `}</style>
    </div>
  );
}
